import { render, staticRenderFns } from "./BaseRegistrationForBusinessUserStepFive.vue?vue&type=template&id=4869c756&"
import script from "./BaseRegistrationForBusinessUserStepFive.vue?vue&type=script&lang=js&"
export * from "./BaseRegistrationForBusinessUserStepFive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports